export const ToggleOffIcon = props => (
  <span {...props}>
    <svg
      width="49"
      height="22"
      viewBox="0 0 49 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="47" height="20" rx="10" fill="#EEF8FB" />
      <rect
        x="1"
        y="1"
        width="47"
        height="20"
        rx="10"
        stroke={props.stroke ? props.stroke : '#374151'}
        strokeWidth="1"
      />
      <circle
        cx="12"
        cy="11"
        r="6"
        fill={props.fill ? props.fill : '#4B5563'}
      />
      <path
        d="M31.992 15H30.312L26.508 9.252V15H24.828V6.612H26.508L30.312 12.372V6.612H31.992V15ZM36.6042 15.108C35.9642 15.108 35.3882 14.968 34.8762 14.688C34.3642 14.4 33.9602 13.996 33.6642 13.476C33.3762 12.956 33.2322 12.356 33.2322 11.676C33.2322 10.996 33.3802 10.396 33.6762 9.876C33.9802 9.356 34.3922 8.956 34.9122 8.676C35.4322 8.388 36.0122 8.244 36.6522 8.244C37.2922 8.244 37.8722 8.388 38.3922 8.676C38.9122 8.956 39.3202 9.356 39.6162 9.876C39.9202 10.396 40.0722 10.996 40.0722 11.676C40.0722 12.356 39.9162 12.956 39.6042 13.476C39.3002 13.996 38.8842 14.4 38.3562 14.688C37.8362 14.968 37.2522 15.108 36.6042 15.108ZM36.6042 13.644C36.9082 13.644 37.1922 13.572 37.4562 13.428C37.7282 13.276 37.9442 13.052 38.1042 12.756C38.2642 12.46 38.3442 12.1 38.3442 11.676C38.3442 11.044 38.1762 10.56 37.8402 10.224C37.5122 9.88 37.1082 9.708 36.6282 9.708C36.1482 9.708 35.7442 9.88 35.4162 10.224C35.0962 10.56 34.9362 11.044 34.9362 11.676C34.9362 12.308 35.0922 12.796 35.4042 13.14C35.7242 13.476 36.1242 13.644 36.6042 13.644Z"
        fill={props.fill ? props.fill : '#4B5563'}
      />
    </svg>
  </span>
);
